module.exports = __webpack_public_path__ + "static/media/chiken.c9304e61.jpg";